module.exports = __webpack_public_path__ + "static/media/bg-marvel.fd7b9001.jpg";